const DEFAULT_LOCALE = 'pl';

export const getLanguageFromDomain = () => {
  const hostname = window?.location?.hostname;

  if (!hostname) return DEFAULT_LOCALE;

  const isCS = hostname.startsWith('www-cz.dev') || hostname.includes('empikfoto.cz');
  if (isCS) {
    return 'cs';
  }

  const isSK = hostname.startsWith('www-sk.dev') || hostname.includes('empikfoto.sk');
  if (isSK) {
    return 'sk';
  }

  const isRO = hostname.startsWith('www-ro.dev') || hostname.includes('empikfoto.ro');
  if (isRO) {
    return 'ro';
  }

  const isHU = hostname.startsWith('www-hu.dev') || hostname.includes('empikfoto.hu');
  if (isHU) {
    return 'hu';
  }

  const isBG = hostname.startsWith('www-bg.dev') || hostname.includes('empikfoto.bg');
  if (isBG) {
    return 'bg';
  }

  return DEFAULT_LOCALE;
};
